import React, { useEffect, useState } from "react";
import "../../css/my style.css";
import "../../css/my style3.css";
import "../../css/special styles.css";
import "../../components/my script";
import Sidenav from "../../components/Sidenav/ReactSidenav";
import Navbar from "../../components/navbar";
import Footertutorials from "../../components/Footer-tutorials";
import SyntaxHighlighterComponent from "../../components/SyntaxHighlighterComponent";
import ButtonNext from "../../components/Buttonnext";
import Tryitout from "../../components/Tryitoutbutton";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import ScrollToTopLink from "../../components/ScrollToTop";
import { getAuthStatus, saveAuthStatus } from "../../localstorage";
import DemoProgress from "../../components/Tutorial Progress/DemoProgress";
import ButtonHome from "../../components/Buttonhome";



export default function Reactintro() {

  

    var newCode = {
    padding: '20px',
    textAlign: 'left',
    background: 'white',
    color: 'black'
    }
    var secondCode = {
        color: 'black'
    }
    var thirdCode = {
        padding: '20px'
    }

    const code=`
    import React, { useState } from 'react';

    const BasicReactExample = () => {
      const [count, setCount] = useState(0);
    
      const increment = () => {
        setCount(count + 1);
      };
    
      return (
        <div>
          <h1>Hello, React!</h1>
          <p>Count: {count}</p>
          <button onClick={increment}>Increment</button>
        </div>
      );
    }
    
    export default BasicReactExample;
    
    `
   
    return (
   <body>
     <Helmet>
     <title>React Tutorial</title>
     <meta charset="UTF-8" />
    <meta http-equiv="X-UA-compatible" content="IE-edge"/>
    <meta name="Keywords" content="Introduction to React JS, What is React JS, What is React, Key Concepts of React JS, Advantages of React JS,
     Step-by-step React programming tutorials, React coding exercises for beginners, Advanced React coding techniques, Best practices for programming beginners,Search Engine Optimization Guide and tips
       React programming tips for real-world applications." />
   <meta name="description" content="Explore the power of React JS on our React tutorial page. Learn how to use React to streamline code organization, enhance code reusability,
    and unlock advanced features in React development. Discover practical examples and best practices to elevate your programming skills. Dive into the world of React JS with our concise and informative guide" />
    <meta name="viewport" content="width=device-width,initial-scale=1.0" />

    </Helmet>
    <br />
        <br />
        <br />
        <br />
        <br />
    <Sidenav />
 
    <div className="content">

<header className="headertutorials" style={newCode}>
<ScrollToTopLink to="/"><ButtonHome /></ScrollToTopLink>
<ScrollToTopLink to="/React_environment_setup"><ButtonNext /></ScrollToTopLink>
   <h1 style={secondCode}>React Introduction</h1>
</header>

<Navbar />

<main>
<section>
  <h1>What is React</h1>
<p>React is a widely-used JavaScript library for building user interfaces. </p>
<p>It was developed by Facebook and is known for its efficiency, modularity, and component-based architecture.</p>
<h2>Basic Example</h2>
<p>This is a basic example in React</p>
<SyntaxHighlighterComponent code={code} language="js" />

<h2>Key Concepts of React JS</h2>
<ol type="1">
<li>Components: React is built around the idea of components. Components are reusable and self-contained building blocks
   that encapsulate UI elements and their behavior.This modular approach promotes maintainability and reusability.</li>
   <br />
<li>Virtual DOM: React uses a Virtual DOM to optimize the rendering process. It creates a lightweight 
  representation of the actual DOM in memory, making updates more efficient by minimizing direct interactions 
  with the real DOM.</li>
  <br />
<li>Unidirectional Data Flow: React follows a unidirectional data flow, where data flows in a single direction 
  from parent components to child components. This ensures predictable and manageable state changes.</li>
  <br />
  <li>JSX (JavaScript XML): JSX is a syntax extension for JavaScript that allows you to write HTML-like code within 
    your JavaScript. It makes React components more readable and intuitive.</li>
  </ol>
  </section>

<section>
  <h2>Advantages of React</h2>
  <ol type="1">
  <li>Efficiency: React's Virtual DOM efficiently updates only the necessary parts of the actual DOM, reducing the
     performance overhead.</li>
     <br />
  <li>Reusability: Component-based architecture encourages the creation of reusable components, which speeds up
     development and reduces code duplication.</li>
     <br />
    <li>Declarative Syntax: React's declarative approach lets you describe how your UI should look based on 
      the current state. It abstracts away the low-level manipulations of the DOM.</li>
      <br />
    <li>Ecosystem: React has a vibrant ecosystem with a vast collection of libraries, tools, and extensions to 
      enhance your development workflow.</li>
    </ol>
</section>

<div className="second-div">
 
     <section className="features">
     <div className="progress-sample">
    
         <img src={require('../../image/beta-progress.svg').default} width={500} height={500}  alt='betathread' />
       <p style={{fontSize: '15px'}}> Our Progress Tracker is designed to help you monitor your progress through our extensive range of tutorials.</p>
       <ScrollToTopLink to="/progress-tracker"><button type="submit" className="buttonb">Track Progress</button></ScrollToTopLink>
   
     </div>

     <div className="progress-sampling">
     <h1 style={{fontSize: '45px'}}>Track Your Progress</h1>
     <DemoProgress />
     </div>
   </section>
  </div>
</main>
<div className="head">
<ScrollToTopLink to="/"><ButtonHome /></ScrollToTopLink>
<ScrollToTopLink to="/React_environment_setup"><ButtonNext /></ScrollToTopLink>
</div>

</div>

<Footertutorials />
   </body>
    )
}